module.exports = __webpack_public_path__ + "static/media/no-image-available.35e8812c.svg";